import React from 'react';
import { DETAILS_FIELD_GROUPS_UPDATED, DetailsFieldGroup, useDetailsFieldGroupsAdminService } from 'nekst-api';
import { Cell, List, ListDataRefresher, useShowContextRequired } from 'ui-builder';
import TextField from '../../../shared/uibuilder/show/field/TextField';
import InnerBlock from '../../../shared/web/layout/InnerBlock';
import { CreateGroupButton } from './CreateGroupForm';
import { GridLayout, IconDeleteButton, IconType, OpenFormIconButton } from 'features/nekst-widgets';
import { UpdateGroupForm } from './UpdateGroupForm';

function DeleteGroupButton() {
  const showContext = useShowContextRequired<DetailsFieldGroup>();
  const detailsFieldGroupsService = useDetailsFieldGroupsAdminService();

  return (
    <IconDeleteButton
      deleteFunc={async () => {
        await detailsFieldGroupsService.deleteGroup(showContext.data!.id);
      }}
      message={`Are you sure you want to delete group "${showContext.data!.name}"?`}
    />
  );
}

function EditGroupButton() {
  return (
    <OpenFormIconButton
      form={<UpdateGroupForm />}
      type={IconType.PENCIL}
      title="Edit Group"
    />
  );
}

export default function DetailsFieldGroupsList() {
  const detailsFieldGroupsService = useDetailsFieldGroupsAdminService();

  return (
    <InnerBlock title="Details Boxes Groups" headerRight={<CreateGroupButton />}>
      <List
        getDataFunc={detailsFieldGroupsService.getGroups}
        updateOnEvents={[DETAILS_FIELD_GROUPS_UPDATED]}
      >
        <GridLayout
          weights={[5, 3, 2]}
          noDataMessage="No details boxes groups have been created yet."
        >
          <TextField source="name" label="Group Name" />
          <Cell label="Actions">
            <EditGroupButton />
            <DeleteGroupButton />
          </Cell>
        </GridLayout>
        <ListDataRefresher eventName={DETAILS_FIELD_GROUPS_UPDATED} />
      </List>
    </InnerBlock>
  );
}
